<div *ngIf="obj()" id="overview-container">

  <div class="common-container">

    <div *ngIf="obj().stId" class="row">
      <div class="label">Stable identifier</div>
      <div class="value">{{ obj().stId }}</div>
    </div>

    <div class="row">
      <div class="label">Type</div>
      <div class="value">
        <!-- Display category for RLE -->
        <ng-container *ngIf="category; else showClassName">
          {{ category() | titlecase }} {{ className() }}
          <ng-container *ngIf="obj().schemaClass === 'Polymerisation' || obj().schemaClass === 'Depolymerisation'">
            &middot; <span class='italic'>{{ obj().schemaClass }}</span>
          </ng-container>
        </ng-container>

        <ng-template #showClassName>
          {{ className() === 'TopLevelPathway' ? 'Pathway' : className() }}
          <ng-container *ngIf="obj().schemaClass !== className()">
            [{{ obj().schemaClass }}]
          </ng-container>
        </ng-template>
      </div>
    </div>

    <div *ngIf="cellType()" class="row">
      <div class="label">Cell Type</div>
      <div class="value compartment-row">
        @for (type of cellType(); track type.dbId; let i = $index; ) {
          <cr-ontology-term [term]="type"></cr-ontology-term>
          <!-- Add comma separator except for last item -->
          @if (i < cellType().length - 1) {
            <span class="comma">,</span>
          }
        }
      </div>
    </div>

    <div *ngIf="speciesName() && showSpecies()" class="row">
      <div class="label">Species</div>
      <div class="value">{{ speciesName() }}</div>
    </div>

    <div *ngIf="compartment()" class="row">
      <div class="label">Compartment</div>
      <div class="value compartment-row">
        @for (has of compartment(); track has.element.dbId; let i = $index; ) {
          <cr-ontology-term [term]="has.element"/>
          <!-- Add comma separator except for last item -->
          @if (i < compartment().length - 1) {
            <span class="comma">,</span>
          }
        }
      </div>
    </div>


    <div *ngIf="disease()" class="row">
      <div class="label">Disease</div>
      <div class="value compartment-row">
        @for (d of disease(); track d.dbId; let i = $index; ) {
          <cr-ontology-term [term]="d" [titleCase]="true"/>
          <!-- Add comma separator except for last item -->
          @if (i < disease().length - 1) {
            <span class="comma">,</span>
          }
        }
      </div>
    </div>

    @if ((name().length || 0) > 1) {
      <div class="row">
        <div class="label">Synonyms</div>
        <div class="value">{{ name().slice(1) }}</div>
      </div>
    }


    @if (organ()) {
      <div class="row">
        <div class="label">Organ</div>
        <div class="value">
          <cr-ontology-term [term]="organ()"/>
        </div>
      </div>
    }

    @if (tissue()) {
      <div class="row">
        <div class="label">Tissue</div>
        <div class="value"><cr-ontology-term [term]="tissue()"/> </div>
      </div>
    }

    @if (tissueLayer()) {
      <div class="row">
        <div class="label">Tissue Layer</div>
        <div class="value"><cr-ontology-term [term]="tissueLayer()"/></div>
      </div>
    }


  </div>

  <!-- Common info ends here-->

  @if (reviewStatus()) {
    <div class="row">
      <div class="label">Review Status</div>
      <div class="value spinner-container">
        <mat-progress-spinner color="primary" mode="determinate"
                              [value]="reviewStar[reviewStatus()!.displayName!].percentage"></mat-progress-spinner>
        <div class="score"> {{ reviewStar[reviewStatus()!.displayName!].score }}/5</div>
      </div>
    </div>
  }

  @if (summations()) {
    <div class="row">
      <div class="label">Summation</div>
      <div class="value flex-grow" >
        @for (summation of summations(); track $index) {
          <div [innerHTML]="summation.text | includeRef: allRefs()" [class.columns]="summation.text.length > 500"></div>

          <!--Display summation refs if is available-->
          @if (summation.literatureReference && summation.literatureReference.length > 0) {
            <div class="summation-refs-container">
              <cr-refs-tree [referenceHolder]=summation></cr-refs-tree>
            </div>
          }
        }
      </div>
    </div>
  }
</div>
